/**
 * GA4 (Firebase) 埋点封装 —— SPAR-593
 * Web 支付页事件全部由前端通过 gtag.js 上报，服务端不发 Measurement Protocol。
 */

// GA4 Web 数据流 Measurement ID（Android App 走独立的 Firebase App 数据流，靠 user_id 关联）
export const GA_MEASUREMENT_ID = 'G-TP01XFRD2Y'

const GTAG_SRC = 'https://www.googletagmanager.com/gtag/js?id=' + GA_MEASUREMENT_ID

// 我们的 planId -> PM 定义的上报值
const PLAN_ID_MAP = {
  go_app_basic_monthly: 'starter_monthly',
  go_app_pro_monthly: 'unlimited_monthly',
  go_app_basic_yearly: 'starter_annual',
  go_app_pro_yearly: 'unlimited_annual'
}

/**
 * 将 planId 映射为 PM 定义的上报值
 * 未命中时原样返回，保留可诊断信息而不是上报 undefined
 * @param {string} planId
 * @returns {string}
 */
export function mapPlan (planId) {
  if (!planId) return ''
  return PLAN_ID_MAP[planId] || planId
}

/**
 * 上报一个 GA4 事件
 * gtag 未加载（脚本失败/被广告拦截）时静默跳过，绝不阻断支付流程
 * 统一使用 beacon 传输，避免用户支付后立即跳转/关页导致事件丢失
 * @param {string} name 事件名
 * @param {object} [params] 事件参数
 * @returns {boolean} 是否成功交给 gtag
 */
export function trackEvent (name, params) {
  if (typeof window === 'undefined' || typeof window.gtag !== 'function') return false
  window.gtag('event', name, { ...params, transport_type: 'beacon' })
  return true
}

/**
 * 全局设置 user_id，供后续所有事件关联回 App 用户
 * @param {string} userId TVU userId
 */
export function setGaUserId (userId) {
  if (!userId) return
  if (typeof window === 'undefined' || typeof window.gtag !== 'function') return
  window.gtag('set', { user_id: userId })
}

/**
 * 加载并初始化 gtag.js（幂等）
 * 只在需要埋点的页面调用，避免污染 dashboard / 微应用 iframe 的数据
 * 注意：前端只用 Measurement ID，api_secret 是服务端 Measurement Protocol 专用，不得放前端
 */
export function initGa () {
  if (typeof window === 'undefined' || typeof document === 'undefined') return
  if (document.querySelector('script[src="' + GTAG_SRC + '"]')) return

  window.dataLayer = window.dataLayer || []
  window.gtag = window.gtag || function () { window.dataLayer.push(arguments) }
  window.gtag('js', new Date())
  window.gtag('config', GA_MEASUREMENT_ID)

  const script = document.createElement('script')
  script.async = true
  script.src = GTAG_SRC
  document.head.appendChild(script)
}
